<template>
  <div
    class="bcsv-pager"
    :class="{ 'bcsv-pager--foot': foot }">
    <div class="bcsv-pager-size">
      <span>Rows per page:</span>
      <span class="bcsv-pager-select">
        <select
          :value="limit"
          @change="onLimit">
          <option
            v-for="option in limitOptions"
            :key="option"
            :value="option">
            {{ option }}
          </option>
        </select>
        <svg
          width="12"
          height="12"
          viewBox="0 0 14 14"
          fill="none"
          stroke="#6B7280"
          stroke-width="1.5">
          <path d="M3.5 5.5 7 9l3.5-3.5" />
        </svg>
      </span>
    </div>

    <div class="bcsv-pager-info">
      {{ rangeText }}
    </div>

    <div class="bcsv-pager-btns">
      <button
        type="button"
        class="bcsv-pager-btn"
        :disabled="page <= 1"
        @click="$emit('update:page', page - 1)">
        ‹
      </button>
      <button
        type="button"
        class="bcsv-pager-btn"
        :disabled="page >= totalPages"
        @click="$emit('update:page', page + 1)">
        ›
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BatchTransferPaginationBar',
  props: {
    page: {
      type: Number,
      required: true
    },
    limit: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      default: 0
    },
    limitOptions: {
      type: Array,
      default: () => [10, 25, 50]
    },
    foot: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    totalPages () {
      return Math.max(1, Math.ceil(this.total / this.limit))
    },
    rangeText () {
      if (!this.total) return '0–0 of 0'
      const from = ((this.page - 1) * this.limit) + 1
      const to = Math.min(this.page * this.limit, this.total)
      return `${from}–${to} of ${this.total}`
    }
  },
  methods: {
    onLimit (event) {
      // เปลี่ยนจำนวนแถวต่อหน้าต้องกลับไปหน้า 1 เสมอ ไม่งั้นอาจค้างอยู่หน้าที่ไม่มีข้อมูลแล้ว
      this.$emit('update:limit', Number(event.target.value))
    }
  }
}
</script>
